// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".buy-dialog .el-dialog__header,.checkout-counter .el-dialog__header{border-bottom:1px solid #f2f2f2;padding:20px 32px 10px 32px}", ""]);
// Exports
module.exports = exports;
